<template>
    <div v-if="editor" class="container">
    
        <div class="control-group ">
            <div class="button-group border border-b-0 rounded-t-[5px] border-[#ccc] p-2">
                <button class="p-1" @click="editor.chain().focus().toggleBulletList().run()" :class="{ 'bg-teal/10': editor.isActive('bulletList') }">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="8" y1="6" x2="21" y2="6"></line>
                    <line x1="8" y1="12" x2="21" y2="12"></line>
                    <line x1="8" y1="18" x2="21" y2="18"></line>
                    <circle cx="3" cy="6" r="1"></circle>
                    <circle cx="3" cy="12" r="1"></circle>
                    <circle cx="3" cy="18" r="1"></circle>
                  </svg>
                </button>
            </div>
        </div>
        <editor-content :editor="editor" />
    </div>
</template>

<script>
import StarterKit from '@tiptap/starter-kit'
import { Editor, EditorContent } from '@tiptap/vue-3'

export default {
    components: {
        EditorContent,
    },

    props: {
        modelValue: {
            type: String,
            default: '',
        },
    },

    emits: ['update:modelValue'],

    data() {
        return {
            editor: null,
        }
    },

    watch: {
        modelValue(value) {
            // HTML
            const isSame = this.editor.getHTML() === value

            // JSON
            // const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)

            if (isSame) {
                return
            }

            this.editor.commands.setContent(value, false)
        },
    },

    mounted() {
        this.editor = new Editor({
            extensions: [
                StarterKit.configure({
                    // Disable an included extension
                    history: false,

                    // Configure an included extension
                    heading: {
                        levels: [1, 2],
                    },
                }),

            ],
            content: this.modelValue,
            onUpdate: () => {
                // HTML
                this.$emit('update:modelValue', this.editor.getHTML())

                // JSON
                // this.$emit('update:modelValue', this.editor.getJSON())
            },
        })
    },

    beforeUnmount() {
        this.editor.destroy()
    },
}
</script>

<style>
/* Basic editor styles */

.tiptap {
    padding: 10px;
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    border-left: 1px solid #ccc;
    border-top: 1px solid #ccc;
    border-radius: 0 0 5px 5px;
    :first-child {
        margin-top: 0;
    }
}

.tiptap ul {
    /* List styles */
    list-style-type: disc;
    padding: 0 1rem;
    margin: 1.25rem 1rem 1.25rem 0.4rem;
    /* Heading styles */
}

.tiptap p {
    margin-bottom: 10px;
}

.tiptap ul li p {
    margin-top: 0.25em;
    margin-bottom: 0.25em;
}
</style>